import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09d7fcd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel",
  style: {"gap":"0px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "User State", -1))
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label details" }, "Number of Employees", -1))
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label details" }, "Job Level", -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label details" }, "Job Level", -1))
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label details" }, "Executive Report", -1))
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label details" }, "Business Activity", -1))
const _hoisted_13 = { class: "field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DataTable, {
        value: _ctx.refUserState,
        stripedRows: "",
        scrollable: "",
        scrollHeight: "200px",
        tableStyle: "width: 600px;"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID",
            style: {"width":"100px"}
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Name"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_DataTable, {
        value: _ctx.refNumberOfEmployees,
        stripedRows: "",
        scrollable: "",
        scrollHeight: "200px",
        tableStyle: "width: 600px;"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID",
            style: {"width":"100px"}
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Name"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_DataTable, {
        value: _ctx.refJobLevel,
        stripedRows: "",
        scrollable: "",
        scrollHeight: "200px",
        tableStyle: "width: 600px;"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID",
            style: {"width":"100px"}
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Name"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_DataTable, {
        value: _ctx.refGrossRevenue,
        stripedRows: "",
        scrollable: "",
        scrollHeight: "200px",
        tableStyle: "width: 600px;"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID",
            style: {"width":"100px"}
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Name"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_DataTable, {
        value: _ctx.refExecutiveReport,
        stripedRows: "",
        scrollable: "",
        scrollHeight: "200px",
        tableStyle: "width: 600px;"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID",
            style: {"width":"100px"}
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Name"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_DataTable, {
        value: _ctx.refBusinessActivity,
        stripedRows: "",
        scrollable: "",
        scrollHeight: "200px",
        tableStyle: "width: 600px;"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID",
            style: {"width":"100px"}
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Name"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
}